"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicFormatService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var SeismicFormats_1 = require("../constants/SeismicFormats");
var ARTICLEV2_ICON_CLASS = 'article-type';
var SeismicFormatService = /** @class */ (function () {
    function SeismicFormatService() {
    }
    SeismicFormatService.prototype.isPPTXOrDOCXOrPDF = function (format) {
        return (format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.PPTX ||
            format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.DOCX ||
            format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.PDF);
    };
    SeismicFormatService.prototype.isPPTOrDOC = function (format) {
        return (format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.PPT ||
            format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.DOC);
    };
    SeismicFormatService.prototype.isYOUTUBEOrVIMEO = function (format) {
        return (format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.YOUTUBE ||
            format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.VIMEO);
    };
    SeismicFormatService.prototype.isUrlLink = function (format) {
        return format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.URL;
    };
    SeismicFormatService.prototype.isAudio = function (format) {
        return format.toUpperCase() === SeismicFormats_1.LiveSendSupportedFormats.MP3;
    };
    /**
     * Returns an boolean to indicator if the format support LiveSend
     * @param format
     */
    SeismicFormatService.prototype.isLiveSendType = function (format) {
        return (!!format && Object.values(SeismicFormats_1.LiveSendSupportedFormats).some(function (item) { return item === format.toUpperCase(); }));
    };
    /**
     * Returns all LiveSend supported content formats
     */
    SeismicFormatService.prototype.getLiveSendSupportedFormats = function () {
        return Object.values(SeismicFormats_1.LiveSendSupportedFormats);
    };
    /**
     * Copied from https://github.com/seismic/web-full-bundle-assets/blob/b336218c50e4d97ce0543cc076c64037b3ef8687/src/core/utility/common.service.js#L878
     * Replacement of `commonHelper.getCollaborationFileIcon` or `getCollaborationFileIconClass` in `commonHelper`
     * Notice, this is just a copy of `commonHelper.getCollaborationFileIcon`.
     * There are at least 10 definition of `getCollaborationFileIconClass`,
     * but, maybe, with a subtle differences. If you are trying to replace one of them with this one,
     * please check and verify your feature carefully.
     * @param item
     * @returns
     */
    SeismicFormatService.prototype.getCollaborationFileIcon = function (item) {
        if (item === void 0) { item = {}; }
        if (item.isFolder)
            return 'folder-type';
        var format = item.format || '';
        var iconClass = '';
        if (item.isDynamic) {
            switch (format) {
                case 'PPT':
                case 'PPTX':
                case 'PPTXTABLE':
                    iconClass = 'ppt-form-type';
                    break;
                case 'DOC':
                case 'DOCX':
                case 'DOCXTABLE':
                    iconClass = 'doc-form-type';
                    break;
            }
        }
        else if (item.isArticlev2) {
            iconClass = ARTICLEV2_ICON_CLASS;
        }
        else {
            switch (format) {
                case 'PPT':
                case 'PPTX':
                case 'PPTXTABLE': {
                    if (item.isLiveDocInstance) {
                        iconClass = 'ppt-livedoc-type';
                    }
                    else {
                        iconClass = 'ppt-type';
                    }
                    break;
                }
                case 'DOC':
                case 'DOCX':
                case 'DOCXTABLE': {
                    if (item.isLiveDocInstance) {
                        iconClass = 'doc-livedoc-type';
                    }
                    else {
                        iconClass = 'doc-type';
                    }
                    break;
                }
                case 'PDF': {
                    if (item.isLiveDocInstance) {
                        iconClass = 'pdf-livedoc-type';
                    }
                    else {
                        iconClass = 'pdf-type';
                    }
                    break;
                }
                case 'IMAGE':
                case 'GIF':
                case 'TIF':
                case 'TIFF':
                case 'JPG':
                case 'JPEG':
                case 'PNG':
                case 'BMP':
                    iconClass = 'img-type';
                    break;
                case 'AVI':
                case 'MPEG4':
                case 'M4V':
                case 'WAV':
                case 'MP4':
                case 'MPG':
                case 'MPA':
                case 'MPE':
                case 'RM':
                case 'RAM':
                case 'ASF':
                case 'MOV':
                case 'VOB':
                case 'WMV':
                case 'V3GP':
                    iconClass = 'video-type';
                    break;
                case 'ZIP':
                    iconClass = 'zip-type';
                    break;
                case 'YOUTUBE':
                    iconClass = 'youtobe-type';
                    break;
                case 'VIMEO':
                    iconClass = 'vimeo-type';
                    break;
                case 'XLSX':
                case 'XLS':
                case 'CSV':
                case 'XLSM':
                    iconClass = 'xls-type';
                    break;
                case 'URL':
                case 'GDOC':
                case 'GSLIDES':
                case 'GSHEET':
                    iconClass = 'url-type';
                    break;
                case 'FORM':
                    iconClass = 'form-livedoc-type';
                    break;
                case 'HTML':
                    iconClass = 'article-type';
                    break;
                default:
                    iconClass = 'other-type';
                    break;
            }
        }
        return iconClass;
    };
    SeismicFormatService = __decorate([
        CommonService_decorator_1.CommonService('SeismicFormatService')
    ], SeismicFormatService);
    return SeismicFormatService;
}());
exports.SeismicFormatService = SeismicFormatService;
//# sourceMappingURL=SeismicFromat.service.js.map